import Vue from 'vue'
import Vuex from 'vuex'
// import axios from 'axios' // remove comment if yu needed
import Crud from '../crud'
const model = (payload) => ({
  // columns
  id: payload.id,
  name: payload.name,
  location: payload.location
})
var crud = new Crud('Customers', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  customers: []
}

const mutations = {
  ...crud.mutations
}

const actions = {
  ...crud.actions
}

const getters = {
  ...crud.getters,
  customers: state => state.customers
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
